import MessageReplied from './MessageReplied';

export default MessageReplied;
